<div class="flex flex-justify-center flex-middle">
    <div
         class="w-5 w-12-m w-12-s flex flex-justify-center flex-middle flex-column-m flex-column-s p-t-5-x p-t-5-l p-b-5-x p-b-5-l">
        <p class="s1 no-wrap"
           *iCms="'text' of component"></p>
        <div class="flex flex-wrap flex-justify-center m-a-2-m m-a-2-s"
             [ngStyle]="{'gap': (client.isX || client.isL) ? '12px' : '10px'}"
             style="gap: 12px;">
            @for (label of component.labels; track label) {
            <href class="bg-col-6 p-a-1 p-t-0 p-b-0 b-radius-4"
                  [link]="label.link">
                <p class="p2 col-w"
                   *iCms="'text' of label"></p>
            </href>
            }
        </div>
    </div>
</div>